import { API_VERSIONS, asinzenAdminApi } from "client/api";

// Note
export const getUniteTestNote = (type: string, marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/unit-test/calculate-library/${type}/${marketplace}/note`);

export const getUniteTestNoteById = (categoryId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/unit-test/calculate-library/note/${categoryId}`);

export const addUnitTestNote = (type: string, marketplace: string, query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/unit-test/calculate-library/${type}/${marketplace}/note/add`, query);

export const updateUnitTestNote = (id: string, query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/unit-test/calculate-library/note/${id}/update`, query);

export const deleteUnitTestNote = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/unit-test/calculate-library/note/${id}/delete`);

// Referral Fee
export const getReferralFeeAsins = (categoryId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/unit-test/calculate-library/referral-fee/${categoryId}/asins`);

export const addReferralFeeAsin = (categoryId: string, query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/unit-test/calculate-library/referral-fee/${categoryId}/asin/add`, query);

export const updateReferralFeeAsin = (idCategory: string, query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/unit-test/calculate-library/referral-fee/${idCategory}/asins/update`, query);

export const deleteReferralFeeAsin = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/unit-test/calculate-library/referral-fee/asin/${id}/delete`);

// Fulfillment Fee
export const addFulfillmentFeeAsin = (marketplace: string, params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/unit-test/calculate-library/fulfillment-fee/${marketplace}/asin/add`, params);

export const updateFulfillmentFeeAsins = (query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/unit-test/calculate-library/fulfillment-fee/asins/update`, query);

export const getFulfillmentFeeAsins = (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/unit-test/calculate-library/fulfillment-fee/${marketplace}/asins`);

export const deleteFulfillmentFeeAsin = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/unit-test/calculate-library/fulfillment-fee/asin/${id}/delete`);

// Size tiers and shipping wgt
export const addSizeTiersShippingWeightAsin = (marketplace: string, params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/unit-test/calculate-library/size-tiers-and-shipping-weight/${marketplace}/asin/add`, params);

export const updateSizeTiersShippingWeightAsin = (query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/unit-test/calculate-library/size-tiers-and-shipping-weight/asins/update`, query);

export const getSizeTiersShippingWeightAsins = (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/unit-test/calculate-library/size-tiers-and-shipping-weight/${marketplace}/asins`);

export const deleteSizeTiersShippingWeightAsin = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/unit-test/calculate-library/size-tiers-and-shipping-weight/asin/${id}/delete`);

// Monthly and Long term storage fee
export const addMonthlyLongTermStorageFeeAsin = (marketplace: string, params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/unit-test/calculate-library/monthly-and-long-term-storage-fee/${marketplace}/asin/add`, params);

export const updateMonthlyLongTermStorageFeeAsins = (query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .put(`/${API_VERSIONS}/unit-test/calculate-library/monthly-and-long-term-storage-fee/asins/update`, query);

export const getMonthlyLongTermStorageFeeAsins = (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/unit-test/calculate-library/monthly-and-long-term-storage-fee/${marketplace}/asins`);

export const deleteMonthlyLongTermStorageFeeAsin = (id: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/unit-test/calculate-library/monthly-and-long-term-storage-fee/asin/${id}/delete`);

// calculate
export const calculateSizeTiersShippingWeight = (params: any) =>
  asinzenAdminApi({})
    .post(`/${API_VERSIONS}/unit-test/calculator-library/calculate-size-tiers-and-shipping-weight`, params);

export const calculateMonthlyAndLongTermStorageFee = (params: any) =>
  asinzenAdminApi({})
    .post(`/${API_VERSIONS}/unit-test/calculator-library/calculate-monthly-and-long-term-storage-fee`, params);

export const calculateFulfillmentFee = (marketplace: string, params: any) =>
  asinzenAdminApi({})
    .post(`/${API_VERSIONS}/unit-test/calculator-library/calculate-fulfillment-fee/${marketplace}`, params);

export const calculateReferralFees = (marketplace: string, cateogry: string, params: any) =>
  asinzenAdminApi({})
    .post(`/${API_VERSIONS}/unit-test/calculator-library/calculate-referral-fee-and-closing-fee/${marketplace}/${cateogry}`, params);